<section class="stepper">
	<div
		class="stepper__content"
		[class.display-content]="selected"
	>
		<div [ngTemplateOutlet]="selected ? selected.content : null"></div>
		<div class="stepper__toggles">
			@for (step of steps; track step) {
				<div
					class="step-toggle"
					role="button"
					tabindex="0"
					[class.step-active]="selectedIndex === $index"
					(click)="onStepClick(step)"
					(keydown.enter)="onStepClick(step)"
				></div>
			}
		</div>
	</div>

	<footer class="stepper__footer">
		<button
			class="stepper__button button flat"
			type="button"
			(click)="onNextStepClick()"
		>
			{{ nextButtonText }}
		</button>
	</footer>
</section>
